import React, { useId, useState } from 'react';
import { Box, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { DeleteOutline, ExpandMore, PauseCircleOutline, PlayCircleOutline } from '@mui/icons-material';
import Button from './Button';

const RowActions = ({ onEdit, onDelete, onToggle, active, disabled, label = 'registro' }) => {
  const [anchor, setAnchor] = useState(null);
  const menuId = useId();
  const run = (action) => { setAnchor(null); action?.(); };
  return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }} onClick={event => event.stopPropagation()}>
    {onEdit && <Button variant="contained" size="sm" onClick={onEdit} disabled={disabled} sx={{ px: 2, bgcolor: '#3b82f6 !important', color: '#fff !important', '&:hover': { bgcolor: '#2563eb !important' } }}>Editar</Button>}
    <Button variant="secondary" size="sm" disabled={disabled} aria-label={'Más acciones: ' + label} aria-haspopup="menu"
      aria-controls={anchor ? menuId : undefined} aria-expanded={!!anchor} endIcon={<ExpandMore fontSize="small" />}
      onClick={event => setAnchor(event.currentTarget)} sx={{ px: 1.75, borderColor: 'divider', color: 'text.secondary' }}>Más acciones</Button>
    <Menu id={menuId} anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
      {onToggle && <MenuItem onClick={() => run(onToggle)}><ListItemIcon>{active ? <PauseCircleOutline fontSize="small" /> : <PlayCircleOutline fontSize="small" />}</ListItemIcon>{active ? 'Desactivar' : 'Activar'}</MenuItem>}
      {onDelete && <MenuItem onClick={() => run(onDelete)} sx={{ color: 'error.main' }}><ListItemIcon sx={{ color: 'inherit' }}><DeleteOutline fontSize="small" /></ListItemIcon>Eliminar</MenuItem>}
    </Menu>
  </Box>;
};
export default RowActions;
